module.exports = __webpack_public_path__ + "static/media/trustinvest2.1706475c.jpeg";